export enum MessageError {
  Send = 'send',
  Edit = 'edit',
  Delete = 'delete',
  DeleteByMe = 'deleteByMe',
  Forward = 'forward',
  Schedule = 'schedule',
}
